import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { adminUpdateUserApi } from 'redux/actions/adminPtPlus/index';
import { Container, AccordionHeader, AccordionBody, InputFieldsWrapper } from '.././PTPlusStyled'
import NumberInput from 'web/components/form-elements/NumberInput';
import RadioButton from 'web/components/form-elements/RadioButton';
import { Field } from 'formik'
import { storeAdminDetails, logoutAdmin } from 'redux/actions/admin';
import EditIcon from "web/assets/svg/PtPlusUserViewEditIcon";
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";

import AlertModal from 'web/components/AlertModal';

function PaymentMethod(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const [accordionOpen, setAccordionOpen] = useState(false)
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');
    let paymentModeList = [{ value: "PT", label: 'PalletTrader Payment' }]

    let invoiceScheduleList = [{ value: "DAILY", label: 'By Order', desc: 'Individual invoices will generate by order, upon load completion.' },
    { value: "WEEKLY", label: 'Weekly (7 Days)', desc: 'Invoices will generate every Monday for the previous week (Mon-Sun).' },
    { value: "MONTHLY", label: 'Monthly (30 Days)', desc: 'Invoices will generate on the first of each month for the previous month.' }]

    const [tooltip, setTooltip] = useState(false);
    const [tooltipSection, setTooltipSection] = useState('');
    const iIcon = (infoSection, infoTxt) => {
        return <>
            <img
                id={infoSection}
                src={information}
                style={{ position: "relative", top: "2px", left: '-5px' }}
                alt='information-icon'
            />
            <Tooltip
                placement="right"
                isOpen={tooltip && tooltipSection === infoSection}
                target={infoSection}
                toggle={() => {
                    setTooltip(!tooltip)
                    setTooltipSection(tooltipSection === '' ? infoSection : '')
                }
                }
            >
                {infoTxt}
            </Tooltip>
        </>
    }

    const updateApiFunction = async () => {
        let id = pageProps.pageData.id
        let url = `ptms/internal/payment_details_update/${id}`
        let fieldValues = pageProps.formikProps.values
        let response = '';
        let paymentTermValue = fieldValues.paymentTerm ? parseInt(fieldValues.paymentTerm) : ''
        if (!(paymentTermValue && paymentTermValue > 0)) {
            setAlertModalContent('Please enter a valid payment term.')
            setAlertModal(!alertModal)
        } else {
            let data = {
                paymentMode: fieldValues.paymentModeRadio,
                invoiceScheduled: fieldValues.invoiceSchedulePeriod,
                paymentTerm: paymentTermValue + ' Days'
            }
            const token = localStorage.getItem('token')
            response = await dispatch(adminUpdateUserApi(url, data, token))
            if (response.success) {
                setAlertModalContent('Detail has been updated successfully.')
                setAlertModal(!alertModal)
            } else {
                if (response.statusCode === 401) {
                    adminLogout()
                } else {
                    setAlertModalContent(response.message)
                    setAlertModal(!alertModal)
                }
            }
        }
    }

    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
        window.location.reload(false);
    }
    const resetFieldsFunction = () => {
        const initailData = pageProps.pageData
        pageProps.setFieldValue('invoiceSchedulePeriod', initailData.invoiceScheduled)
    }

    return (
        <>
            <Container>
                <AccordionHeader>
                    <h6 onClick={() => {
                        if (accordionOpen) setAccordionOpen(false)
                        else setAccordionOpen(true)
                    }}>Payment Method</h6>
                    {accordionOpen ?
                        <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
                        : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
                    }
                </AccordionHeader>
                {accordionOpen &&
                    <AccordionBody>
                        <div>
                            <InputFieldsWrapper>
                                <h6 style={{ fontWeight: 'bold', fontSize: '15px', color: '#000' }}>Payment Mode<span className='star'>&#42;</span></h6>
                                <div className="row mt-3">
                                    {paymentModeList.map((value, index) => (
                                        <div className="col-md-6">
                                            <div key={index}>
                                                <Field
                                                    component={RadioButton}
                                                    name="paymentModeRadio"
                                                    id={value.value}
                                                    defaultValue={paymentModeList[0].value}
                                                    onSelect={(e) => {
                                                        if (e.target.value === "percentage") {
                                                        }
                                                    }}
                                                    label={value.label}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </InputFieldsWrapper>

                            <InputFieldsWrapper>
                                <h6 style={{ fontWeight: 'bold', fontSize: '15px', color: '#000', marginTop: '15px' }}>Payment Term<span className='star'>&#42;</span></h6>
                                <div className="row mt-3">
                                    <div className="col-md-2">
                                        <NumberInput name="paymentTerm" placeholder={`No. of Days`} maxAllowedValueLimit={366} />
                                    </div>
                                </div>
                            </InputFieldsWrapper>

                            <div>
                                <div className='section-header'>
                                    <p style={{ fontWeight: 'bold', fontSize: '15px', color: '#000' }}>Setup Your Invoice Schedule<span className='star'>&#42;</span></p>
                                </div>

                                <div style={{ margin: '15px 0 0 0' }}>
                                    <InputFieldsWrapper>
                                        <h6 style={{ marginTop: '-13px' }}>Invoice will generates as per the selected time period</h6>
                                        <div className="row mt-4">
                                            {invoiceScheduleList.map((value, index) => (
                                                <div className="col-md-3" style={{ display: 'flex' }}>
                                                    <div key={index}>
                                                        <Field
                                                            component={RadioButton}
                                                            name="invoiceSchedulePeriod"
                                                            id={value.value}
                                                            defaultValue={invoiceScheduleList[0].value}
                                                            onSelect={(e) => {
                                                                if (e.target.value === "percentage") {
                                                                }
                                                            }}
                                                            label={value.label}
                                                        />
                                                    </div>
                                                    {iIcon(value.value, value.desc)}
                                                </div>
                                            ))}
                                        </div>
                                    </InputFieldsWrapper>
                                </div>
                            </div>
                        </div>
                        <div className='view-edit-button-section'>
                            <button className='save-button' onClick={() => updateApiFunction()}><EditIcon />Update</button>
                            <button className='cancel-button' onClick={() => resetFieldsFunction()}>Cancel</button>
                        </div>
                    </AccordionBody>
                }
            </Container>

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                title=''
                content={alertModalContent}
            />
        </>
    )
}

export default PaymentMethod
